/** subscriptions make free and premium download permissions a little more complicated.
 *  this is just a facade over that to:
 *  - put the permissions info into one var
 *  - make it more human-readable
 */
import ddt from '@wix/da-ddt';
var logger = ddt.createLogger('downloadbutton');
export var FREE_DOWNLOAD_PERMISSIONS = {
    DOWNLOADABLE: 'downloadable',
    NEEDS_SUBSCRIPTION: 'needs_subscription',
    BLOCKED_BY_SUBSCRIPTION: 'blocked_by_subscription',
};
export function getDeviationFreeDownload(deviation) {
    var _a;
    var freeDownload = (_a = deviation.extended) === null || _a === void 0 ? void 0 : _a.download;
    logger.log('free download', freeDownload);
    if (!freeDownload) {
        return {};
    }
    var permission = FREE_DOWNLOAD_PERMISSIONS.DOWNLOADABLE;
    // the only thing preventing a free download is a subscription
    var tierAccess = deviation.tierAccess;
    if (tierAccess === 'locked') {
        permission = FREE_DOWNLOAD_PERMISSIONS.NEEDS_SUBSCRIPTION;
    }
    if (tierAccess === 'locked-subscribed') {
        permission = FREE_DOWNLOAD_PERMISSIONS.BLOCKED_BY_SUBSCRIPTION;
    }
    logger.log('free download', { tierAccess: tierAccess, permission: permission });
    return { download: freeDownload, permission: permission };
}
export var PREMIUM_DOWNLOAD_PERMISSIONS = {
    DOWNLOADABLE: 'downloadable',
    PURCHASABLE: 'purchasable',
};
export function getDeviationPremiumDownload(deviation, isOwner) {
    var _a;
    var premiumDownload = (_a = deviation.extended) === null || _a === void 0 ? void 0 : _a.pcp;
    logger.log('premium download', premiumDownload);
    if (!premiumDownload) {
        return {};
    }
    // purchasing, unblocked subscriptions, and ownership
    // give access to premium downloads
    var purchasedSeparately = premiumDownload === null || premiumDownload === void 0 ? void 0 : premiumDownload.hasUserPurchased;
    var tierAccess = deviation.tierAccess;
    var hasSubscriptionAccess = tierAccess === 'unlocked';
    var hasPremiumAccess = purchasedSeparately || hasSubscriptionAccess || isOwner;
    var permission = hasPremiumAccess
        ? PREMIUM_DOWNLOAD_PERMISSIONS.DOWNLOADABLE
        : PREMIUM_DOWNLOAD_PERMISSIONS.PURCHASABLE;
    logger.log('premium download', {
        isOwner: isOwner,
        purchasedSeparately: purchasedSeparately,
        tierAccess: tierAccess,
        permission: permission,
    });
    return { download: premiumDownload, permission: permission };
}
//# sourceMappingURL=permissions.js.map